import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const dataVendorInvoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendorInvoices: builder.query({
      query: (dataVendorId) => ({
        url: `/data_vendors/${dataVendorId}/revenues`
      }),
      providesTags: (result = [], error, dataVendorId) => [{ type: 'DataVendorInvoice', id: `${dataVendorId}:LIST` } ],
    }),
    getDataVendorInvoice: builder.query({
      query: ([dataVendorId, year, month]) => ({
        url: `/data_vendors/${dataVendorId}/revenues/${year}/${month}`
      }),
      providesTags: (result = [], error, [dataVendorId, year, month]) => [{ type: 'DataVendorInvoice', id: `${dataVendorId}:${year}:${month}` } ],
    }),
    updateDataVendorInvoice: builder.mutation({
      query: (dataVendorInvoice) => ({
        url: `/data_vendors/${dataVendorInvoice.dataVendorId}/revenues/${dataVendorInvoice.year}/${dataVendorInvoice.month}`,
        method: 'PUT',
        body: dataVendorInvoice
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {dataVendorId, year, month}) => [
        { type: 'DataVendorInvoice', id: `${dataVendorId}:LIST` },
        { type: 'DataVendorInvoice', id: `${dataVendorId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}:${month}` },
      ],
    }),
    destroyDataVendorInvoice: builder.mutation({
      query: ([dataVendorId, year, month]) => ({
        url: `/data_vendors/${dataVendorId}/revenues/${year}/${month}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, [dataVendorId, year, month]) => [
        { type: 'DataVendorInvoice', id: `${dataVendorId}:LIST` },
        { type: 'DataVendorInvoice', id: `${dataVendorId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}/${month}` }
      ],
    }),
    finalizeDataVendorInvoice: builder.mutation({
      query: ([dataVendorId, year, month]) => ({
        url: `/data_vendors/${dataVendorId}/revenues/${year}/${month}/finalize`,
        method: 'PUT'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("dataVendorInvoice.finalized")}),
      invalidatesTags: (result, error, [dataVendorId, year, month]) => [
        { type: 'DataVendorInvoice', id: `${dataVendorId}:LIST` },
        { type: 'DataVendorInvoice', id: `${dataVendorId}:${year}:${month}` },
        { type: 'Invoice', id: `${year}/${month}` }
      ],
    })
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorInvoicesQuery,
  useGetDataVendorInvoiceQuery,
  useUpdateDataVendorInvoiceMutation,
  useFinalizeDataVendorInvoiceMutation,
  useDestroyDataVendorInvoiceMutation
} = dataVendorInvoiceApiSlice
